import React, { Component } from 'react'
import classname from 'classnames'
import { updateTab,
         getStudentPapers,
         getStudSubmissionComplete,
         getUserDetails,
         patchUserId,
         updateUserIdInput
       } from '../../actions/studentdashboard.js'
import config from '../../config/config.json'
import moment from 'moment'
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import StudentProfileForm from './StudentProfileForm.js';
import StudentDashboardMenu from './StudentDashboardMenu.js';
import UpdatePassword from './updatePassword.js';
import TopNav from '../includes/TopNav.js';
import Pager from './Pager.js';
import { getPresentedEnglishType, getFormattedTime, docStatusToString } from '../../util/displayUtils.js';
import { updateUserProfile } from '../../actions/user.js'; 
import {Helmet} from "react-helmet";
import StudentAffiliateCode from './StudentAffiliateCode.js';


class DashboardStudent extends Component {
  componentDidMount() {
      this.getStudentPapers();
      this.getStudSubmissionComplete()
  }
  changeTab(index) {
      this.props.dispatch(updateTab(index))
  }
  getUserDetails(){
      this.props.dispatch(getUserDetails())
  }
  updateUserIdInput(key, e) {
      this.props.dispatch(updateUserIdInput(key, e.target.value))
  }
  patchUserId(){
      this.props.dispatch(patchUserId(this.props.Dashboard.user_details, () => {
      }))
  }
  getStudentPapers(){
      this.props.dispatch(getStudentPapers())
      setTimeout(function(){
        this.getStudentPapers(); 
      }.bind(this), 60*1000);
  }
  getStudSubmissionComplete(){
      this.props.dispatch(getStudSubmissionComplete())
      setTimeout(function(){
        this.getStudentPapers(); 
        this.getStudSubmissionComplete();
      }.bind(this), 60*1000);
  }
  componentWillUpdate(props){
    if( this.props.User && this.props.User.fetched ) { // only after session fetched
      if( this.props.User.role != "student" || !this.props.User.loggedin) {
        window.location.href = "/login";
      }
    }
  }
  getStudentProfileProps(){
    console.log("buidling data props for profile form");
    console.log(this.props.User);
    let data = {
      firstName: this.props.User.first_name,
      lastName: this.props.User.last_name,
      phone: this.props.User.phone,
      email: this.props.User.email
    }
    let initialValues = {
      initialValues: data,
      data
    }
    return initialValues;
  }
  submitStudentUpdate(data) {
    // function to send profile update to API
    console.log("going to send to API ");
    console.log(data);
    updateUserProfile(data);
  }
  getNextPageAvailable(page) {
    this.props.dispatch(getStudentPapers(page))
  }
  getNextPageCompleted(page) {
    this.props.dispatch(getStudSubmissionComplete(page))
  }
  copyAffiliateUrl(url) {

  }
  render() {

    var tab1 = classname({ 'tab': true, 'easing': true, 'active-tab': this.props.Dashboard.tab === 1 })
    var tab3 = classname({ 'tab': true, easing: true, 'active-tab': this.props.Dashboard.tab === 3 })
    var tab4 = classname({ 'tab': true, easing: true, 'active-tab': this.props.Dashboard.tab === 4 })
    var tab5 = classname({ 'tab': true, easing: true, 'active-tab': this.props.Dashboard.tab === 5 })
    var page1 = classname({ 'page': true, easing: true, active: this.props.Dashboard.tab === 1 })
    var page3 = classname({ 'page': true, easing: true, active: this.props.Dashboard.tab === 3 })
    var page4 = classname({ 'page': true, easing: true, active: this.props.Dashboard.tab === 4, 'referralsTab': true })
    var availPapers = this.props.Dashboard.studentSubmissionsAvail.map((submission, i) => {
      var Download = (<a href={config.BASE + '/' + submission.doc_path} target="_blank">Download</a>)
      if(!submission.doc_status){
        submission.doc_status = "unpaid, unedited"
      }
      return(
        <tr className="paper-list" key={i}>
          {console.log("submission")}
          {console.log(submission)}
          {console.log("submission")}
          <td><Link to={`/studentdashboard/view/${submission.doc_id}/`}>{submission.doc_name}</Link></td>
          <td>{submission.word_count}</td>
          <td>${submission.receipt_total_amount + submission.receipt_tax}</td>
          <td>{docStatusToString(submission.doc_status)}</td>
          <td>{submission.time_limit} hours</td>
          <td>{getFormattedTime(submission.upload_date)}</td>
          <td>{getFormattedTime(submission.due_date)}</td>
          <td className="option"> {Download} </td>
        </tr>
      )
    })
    var completePapers = this.props.Dashboard.studentSubmissionsComplete.map((submission, i) => {
      var Download = (<a href={config.BASE + '/' + submission.doc_path} target="_blank">Download</a>)
      let rating_comp;
      if(submission.editor_rating_id){
        rating_comp = <Link to={`/studentdashboard/rating/${submission.doc_id}/`}>{submission.doc_id}</Link>
      }else{
        rating_comp = <Link to={`/studentdashboard/rating/${submission.doc_id}/`}>Rate</Link>
      }
      // var current_time = new Date().getTime()
      // var expires_time = current_time + (parseFloat(submission.time_limit) * ( 1000 * 60 * 60 ))
      // var diff = oneSecond - originalTime
      // var mins = Math.floor(diff / (1000 * 60));
      return(
        <tr className="paper-list" key={i}>
          <td><Link to={`/studentdashboard/view/${submission.doc_id}/`}>{submission.doc_name}</Link></td>
          <td>{submission.word_count}</td>
          <td>${submission.receipt_total_amount + submission.receipt_tax}</td>
          <td>{docStatusToString(submission.doc_status)}</td>
          <td>{submission.time_limit} hours</td>
          <td>{getFormattedTime(submission.upload_date)}</td>
          <td><a href={config.BASE + '/' + submission.edit_path1} target="_blank">{submission.file_name1}</a></td>
          <td><a href={config.BASE + '/' + submission.edit_path2} target="_blank">{submission.file_name2}</a></td>
{/*          <td>{rating_comp}</td> */}
        </tr>
      )
    })
    return(
      <div>
        <Helmet>
          <title>Client Portal | Edit My Paper</title>
          <meta name="viewport" content="width=1280, initial-scale=minimum-scale" />
        </Helmet>
        <TopNav />
        <section className="studentDashboard">
        <div className={tab1}>
          <div className="tab-tile"> Documents in Progress </div>
          <div className="dash-wrapper">
            <StudentDashboardMenu changeTab={this.changeTab.bind(this)} activeItem={this.props.Dashboard.tab} />
            <div className={page1}>
              <div className="refreshMessage">Refresh this page after submitting your paper to update it.</div>
              <table className="dashboard-paperlist">
                <tbody>
                  <tr>
                    <th>Document Name</th>
                    <th>Word Count</th>
                    <th>Price</th>
                    <th>Status</th>
                    <th>Time Limit</th>
                    <th>Submission Date</th>
                    <th>Due Date</th>
                    <th>Download</th>
                  </tr>
                  {availPapers}
                </tbody>
              </table>
              <Pager totalCount={this.props.Dashboard.studentSubmissionsAvailTotalCount} currentPage="1" clickHandler={this.getNextPageAvailable.bind(this)} pageSize="20"></Pager>
              <div style={{"clear": "both", "width": "100%", "marginTop": "10px" }}><a href="/preparations">Click Here</a> for detailed instructions on working with your edited paper.</div>
              {(this.props.User && this.props.User.affiliate_code)?
                <StudentAffiliateCode code={this.props.User.affiliate_code} className="refTabCodeBox" includeLink={true} linkClickHandler={this.changeTab.bind(this, 5)}/>
                :
                <span></span>
              }
            </div>
          </div>
        </div>
        <div className={tab3}>
          <div className="tab-tile"> Completed Documents </div>
          <div className="dash-wrapper">
          <StudentDashboardMenu changeTab={this.changeTab} activeItem={this.props.Dashboard.tab} />
            <div className={page1}>
              <table className="dashboard-paperlist">
                <tbody>
                  <tr>
                    <th>Document Name</th>
                    <th>Word Count</th>
                    <th>Price</th>
                    <th>Status</th>
                    <th>Time Limit</th>
                    <th>Completed Date</th>
                    <th>Download With Edits &amp; Comments</th>
                    <th>Download Clean Version</th>
{/*                    <th>Rate</th>*/}
                  </tr>
                  {completePapers}
                </tbody>
              </table>
              <Pager totalCount={this.props.Dashboard.studentSubmissionsCompleteTotalCount} currentPage="1" clickHandler={this.getNextPageCompleted.bind(this)} pageSize="20"></Pager>
              <div style={{"clear": "both", "width": "100%", "marginTop": "10px" }}><a href="/preparations">Click Here</a> for detailed instructions on working with your edited paper.</div>
              {(this.props.User && this.props.User.affiliate_code)?
                <StudentAffiliateCode code={this.props.User.affiliate_code} className="refTabCodeBox" includeLink={true} linkClickHandler={this.changeTab.bind(this, 5)}/>
                :
                <span></span>
              }
            </div>
          </div>
        </div>
        <div className={tab4}>
          <div className="tab-tile"> My Profile </div>
          <div className="dash-wrapper">
          <StudentDashboardMenu changeTab={this.changeTab} activeItem={this.props.Dashboard.tab}/>
            <div className={page1}>
              <StudentProfileForm onSubmit={this.submitStudentUpdate} {...this.getStudentProfileProps()} />
              <UpdatePassword></UpdatePassword>
            </div>
          </div>
        </div>
        <div className={tab5}>
          <div className="tab-tile"> Referrals </div>
          <div className="dash-wrapper">
            <StudentDashboardMenu changeTab={this.changeTab} activeItem={this.props.Dashboard.tab} />
            <div className={page4} style={{'textAlign': 'left'}}>
              <div>
                <div style={{"width" : "50%", "float": "left"}}>
                {(this.props.User && this.props.User.affiliate_code)?
                  <StudentAffiliateCode code={this.props.User.affiliate_code} className="refTabCodeBox"/>
                :
                  <span></span>
                }
                </div>
                <div style={{"width" : "50%", "float": "right"}}>
                  <div className="refTabCodeBox">
                  Your Balanace: ${this.props.User.balance || 0}<br />
                  </div>
                </div>
              </div>
              <div style={{"width" : "100%", "clear": "both", "paddingTop": "20px"}}>
                <h4>When a referral code is used by your friend on an edit of:</h4>
                <div className="referralLevel">
                  <div className="stars">
                    <i className="fa fa-star" />
                    <i className="fa fa-star-o" />
                    <i className="fa fa-star-o" />
                  </div>
                  <span className="referralWordCount">976</span> to <span className="referralWordCount">2275</span> words
                  <div>
                    <div className="referralYouGetBox">
                      <span className="referralYouGet">You get:</span>
                      <span className="referralBonus">$10</span> account credit
                    </div>
                    <div className="referralYourFriendBox">
                      <span className="referralYourFriend">your friend gets:</span>
                      <span className="referralYourFriendDiscount">$7.50</span> discount
                    </div>
                  </div>
                </div>
                <div className="referralLevel">
                  <div className="stars">
                    <i className="fa fa-star" />
                    <i className="fa fa-star" />
                    <i className="fa fa-star-o" />
                  </div>
                  <span className="referralWordCount">2276</span> to <span className="referralWordCount">5200</span> words
                  <div>
                    <div className="referralYouGetBox">
                      <span className="referralYouGet">You get:</span>
                      <span className="referralBonus">$15</span> account credit
                    </div>
                    <div className="referralYourFriendBox">
                      <span className="referralYourFriend">your friend gets:</span>
                      <span className="referralYourFriendDiscount">$10</span> discount
                    </div>
                  </div>
                </div>
                <div className="referralLevel">
                  <div className="stars">
                    <i className="fa fa-star" />
                    <i className="fa fa-star" />
                    <i className="fa fa-star" />
                  </div>
                  <span className="referralWordCount">5200+</span> words
                  <div>
                    <div className="referralYouGetBox">
                      <span className="referralYouGet">You get:</span>
                      <span className="referralBonus">$20</span> account credit
                    </div>
                    <div className="referralYourFriendBox">
                      <span className="referralYourFriend">your friend gets:</span>
                      <span className="referralYourFriendDiscount">$15</span> discount
                    </div>
                  </div>
                </div>
              </div>
              
              
            </div>
          </div>
        </div>
      </section>
      </div>
    )
  }

}
export default connect( ({Dashboard, User}) => ({Dashboard, User}) ) (DashboardStudent)



// WEBPACK FOOTER //
// ./src/components/dashboards/StudentDashboard.js